import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const ConditionalLink = props => {
  const { condition, to, children, ...rest } = props;
  const doWrap = typeof condition === "boolean" ? condition : !!to;
  return doWrap ? (
    <Link to={to} {...rest}>
      {children}
    </Link>
  ) : (
    children
  );
};

ConditionalLink.propTypes = {
  to: PropTypes.string,
  condition: PropTypes.bool
};

export default ConditionalLink;
